import {
  Box,
  Container,
  Flex,
  HStack,
  Text,
  Link,
  Image,
} from "@chakra-ui/react";
import { FaFacebook, FaInstagram } from "react-icons/fa";

const NAVY = "#141C49";

export const SolarFooter = () => {
  return (
    <Box as="footer" bg={NAVY} color="white">
      <Container maxW="container.xl" px={{ base: 6, md: 10 }}>

        {/* ── Row 1: Logo left / Follow One Solar right ── */}
        <Flex
          justify="space-between"
          align="center"
          py={8}
        >
          <Image
            src="/assets/one-solar-dark.webp"
            alt="One Solar Australia"
            h="70px"
            objectFit="contain"
          />

          <HStack spacing={4} align="center">
            <Text
              fontSize="xs"
              fontWeight="700"
              letterSpacing="widest"
              textTransform="uppercase"
              color="white"
              whiteSpace="nowrap"
            >
              Follow One Solar
            </Text>
            <Link
              href="https://www.facebook.com/One-Solar-100522258324560"
              isExternal
              color="white"
              _hover={{ color: "gray.300" }}
              display="flex"
              alignItems="center"
            >
              <FaFacebook size={22} />
            </Link>
            <Link
              href="https://www.instagram.com/onesolar.australia.official"
              isExternal
              color="white"
              _hover={{ color: "gray.300" }}
              display="flex"
              alignItems="center"
            >
              <FaInstagram size={22} />
            </Link>
          </HStack>
        </Flex>

        {/* ── Divider ── */}
        <Box borderTop="1px solid" borderColor="whiteAlpha.300" />

        {/* ── Row 2: Policy links left / License & copyright right ── */}
        <Flex
          justify="space-between"
          align={{ base: "flex-start", md: "center" }}
          direction={{ base: "column", md: "row" }}
          gap={4}
          py={6}
        >
          {/* Pipe-separated links */}
          <Text fontSize="xs" letterSpacing="wider" textTransform="uppercase" color="whiteAlpha.800" lineHeight="2">
            <Link href="/solar/sponsor" _hover={{ color: "white" }} color="whiteAlpha.800">
              Sponsor
            </Link>
            {" | "}
            <Link href="/solar/capability-statement" _hover={{ color: "white" }} color="whiteAlpha.800">
              Capability Statement
            </Link>
            {" | "}
            <Link href="/privacy" _hover={{ color: "white" }} color="whiteAlpha.800">
              Privacy Policy
            </Link>
            {" | "}
            <br />
            <Link href="/solar/promo-terms" _hover={{ color: "white" }} color="whiteAlpha.800">
              Promotional Terms &amp; Conditions
            </Link>
          </Text>

          {/* License & copyright */}
          <Box textAlign={{ base: "left", md: "right" }} flexShrink={0}>
            <Text fontSize="xs" color="whiteAlpha.800">
              Electrical Contractors License No: 88686.
            </Text>
            <Text fontSize="xs" color="whiteAlpha.800" mt={1}>
              © {new Date().getFullYear()} All Rights Reserved.
            </Text>
          </Box>
        </Flex>

        {/* ── Divider ── */}
        <Box borderTop="1px solid" borderColor="whiteAlpha.300" />

        {/* ── Row 3: Group disclaimer ── */}
        <Box py={6}>
          <Text fontSize="xs" color="whiteAlpha.700" lineHeight="1.9">
            <Text as="span" fontWeight="700" color="white">One Solar Australia</Text>
            {" "}is part of the{" "}
            <Text as="span" fontWeight="700" color="white">One Group Australasia Pty Ltd (ACN: 642 690 435)</Text>
            {" "}family of companies, including{" "}
            <Link href="/finance" fontWeight="700" color="white" _hover={{ textDecoration: "underline" }}>
              One Finance Australia
            </Link>
            {" "}and{" "}
            <Link href="/property" fontWeight="700" color="white" _hover={{ textDecoration: "underline" }}>
              One Property Australia
            </Link>
            . Together, we are committed to delivering innovative and tailored solutions across mortgage and asset finance, property acquisition and solar installation.
          </Text>
        </Box>

      </Container>
    </Box>
  );
};
